const SCHEDULE_TEAM_ROLE_SLUGS = new Set<string>(["consultant", "partner_broker"]);

/**
 * Consultants and partner brokers load /api/adm/teams and use team-scoped schedule APIs.
 * Matching is case-insensitive because login payloads may vary in casing.
 */
export function roleUsesScheduleTeams(role: string | undefined | null): boolean {
  if (role == null || role === "") return false;
  return SCHEDULE_TEAM_ROLE_SLUGS.has(role.trim().toLowerCase());
}
